import React from 'react';
import styles from '../../../styles/UserInformation.module.css';
import profileStyles from '../../../styles/AccountProfile.module.css';
import buttonStyles from '../../../styles/Buttons.module.css';
import { useState } from 'react';
import EditProfile from './EditProfile';
import { useEnhancedAuth } from '../../../contexts/EnhancedAuthContext'; // Phase 2: Enhanced auth
import { PermissionGate } from '../../common/PermissionGate'; // Phase 2: Permission gates

interface UserInformationProps {
    userDetails: any; // Legacy prop - enhanced auth provides user data
    handleProfileChange: (updatedUser: any) => void;
}

const getInitials = (name?: string | null): string => {
    if (!name) return '?';
    const parts = name.trim().split(/\s+/);
    return parts.slice(0, 2).map(p => p[0]?.toUpperCase() || '').join('') || '?';
};

const UserInformation: React.FC<UserInformationProps> = ({ userDetails, handleProfileChange }) => {
    const [showEditProfile, setShowEditProfile] = useState(false);

    // Phase 2: Use enhanced auth for permission checking
    const { userDetails: enhancedUserDetails } = useEnhancedAuth();

    // Use enhanced user details, fallback to legacy prop during transition
    const currentUserDetails = enhancedUserDetails || userDetails;

    return (
        <div className={profileStyles.card}>
            <div className={profileStyles.cardHeader}>
                <div className={profileStyles.avatar}>{getInitials(currentUserDetails?.fullName)}</div>
                <div className={profileStyles.headerText}>
                    <h2 className={profileStyles.headerTitle}>{currentUserDetails?.fullName || 'User Details'}</h2>
                    <p className={profileStyles.headerSubtitle}>{currentUserDetails?.email}</p>
                </div>
                <div className={profileStyles.headerActions}>
                    <PermissionGate requiredPermissions={["doc_edit_own", "doc_edit_all"]} requireAllPermissions={false}>
                        <button
                            className={`${buttonStyles.button} ${buttonStyles.primary}`}
                            onClick={() => setShowEditProfile(true)}
                        >
                            Edit Profile
                        </button>
                    </PermissionGate>
                </div>
            </div>

            <div className={profileStyles.cardBody}>
                <div className={profileStyles.fieldGrid}>
                    <div className={profileStyles.field}>
                        <span className={profileStyles.fieldLabel}>Name</span>
                        <span className={profileStyles.fieldValue}>{currentUserDetails?.fullName}</span>
                    </div>

                    <div className={profileStyles.field}>
                        <span className={profileStyles.fieldLabel}>Email</span>
                        <span className={profileStyles.fieldValue}>{currentUserDetails?.email}</span>
                    </div>

                    <div className={profileStyles.field}>
                        <span className={profileStyles.fieldLabel}>ID Number</span>
                        <span className={profileStyles.fieldValue}>{currentUserDetails?.idNumber}</span>
                    </div>

                    <div className={profileStyles.field}>
                        <span className={profileStyles.fieldLabel}>Mobile Number</span>
                        <span className={profileStyles.fieldValue}>{currentUserDetails?.mobileNumber}</span>
                    </div>

                    <div className={`${profileStyles.field} ${profileStyles.fieldFull}`}>
                        <span className={profileStyles.fieldLabel}>Physical Address</span>
                        <span className={profileStyles.fieldValue}>{currentUserDetails?.fullPhysicalAddress}</span>
                    </div>
                </div>
            </div>

            {/* Edit Profile Dialog */}
            {showEditProfile && (
                <div className={styles.modalBackdrop}>
                    <div className={styles.modalContent}>
                        <EditProfile
                            userDetails={currentUserDetails}
                            onProfileUpdate={updatedUser => {
                                handleProfileChange(updatedUser);
                                setShowEditProfile(false);
                            }}
                            onCancel={() => setShowEditProfile(false)}
                        />
                    </div>
                </div>
            )}
        </div>
    );
};

export default UserInformation;
